import React from "react";
import { InventoryControlPanel } from "./InventoryControlPanel";
import { InventoryTable } from "./InventoryTable";

export const ItemsMasterView = ({
  search,
  setSearch,
  filters,
  setFilters,
  dynamicSettings,
  activeTab,
  filtered,
  setRestockItem,
  handleEdit,
  handleViewPurchases,
  deleteItem,
  distributedMap,
  purchasedMap,
  onExport,
  isExporting,
  loading
}) => {
  return (
    <>
      <InventoryControlPanel
        activeTab={activeTab}
        search={search}
        setSearch={setSearch}
        filters={filters}
        setFilters={setFilters}
        dynamicSettings={dynamicSettings}
        statusPlaceholder="All Status"
        onExport={onExport}
        isExporting={isExporting}
        showCustomerFilter={false}
      />
      {loading ? (
        <div className="flex flex-col items-center justify-center p-12 bg-white/50 border border-slate-100 rounded-xl">
          <div className="w-8 h-8 border-4 border-slate-200 border-t-brand-blue rounded-full animate-spin mb-4" />
          <p className="text-sm font-semibold text-slate-400">Loading inventory data...</p>
        </div>
      ) : (
        <InventoryTable
          filtered={filtered}
          activeTab={activeTab}
          onRestockClick={setRestockItem}
          onEditClick={handleEdit}
          onViewClick={handleViewPurchases}
          onDeleteClick={deleteItem}
          distributedMap={distributedMap}
          purchasedMap={purchasedMap}
        />
      )}
    </>
  );
};

